// components/PriceBreakdown.jsx
import React from "react";
import PriceOfferCell from "./PriceOfferCell"; // your existing editor
import "./PriceBreakdown.scss";

const PriceBreakdown = ({
  t,
  price,
  shipping,
  total,
  onOfferSubmit,
  onOfferCancel,
  editable = true,
}) => {
  return (
    <div className="deal-breakdown">
      {/* Price */}
      <div className="deal-row">
        <div className="deal-label">{t("Price")}</div>
        <div className="deal-value deal-offer">
          {editable ? (
            <PriceOfferCell
              price={price}
              onSubmit={onOfferSubmit}
              onCancel={onOfferCancel}
              t={t}
            />
          ) : (
            <span className="price-chip">{price}$</span>
          )}
        </div>
      </div>

      {/* Shipping */}
      <div className="deal-row">
        <div className="deal-label">{t("Shipping")}</div>
        <div className="deal-value">
          <span className="deal-num">+{shipping}$</span>
        </div>
      </div>

      {/* Total */}
      <div className="deal-row deal-row--total">
        <div className="deal-label">{t("Total")}</div>
        <div className="deal-value">
          <span className="deal-num">{total}$</span>
        </div>
      </div>
    </div>
  );
};

export default PriceBreakdown;
